import { NgModule } from '@angular/core';

//declarations
import { CursosListarComponent } from '../components/cursos/pages/cursos-listar/cursos-listar.component';
import { CursoAltaComponent } from '../components/cursos/pages/curso-alta/curso-alta.component';
import { CursoCompraComponent } from '../components/cursos/pages/curso-compra/curso-compra.component';
import { CursosAlumnosModificarComponent } from '../components/cursos/pages/cursos-alumnos-modificar/cursos-alumnos-modificar.component';
import { CursosListadoAlumnoCursosComponent } from '../components/cursos/pages/cursos-listado-alumno-cursos/cursos-listado-alumno-cursos.component';
import { CursoDescripcionCompraComponent } from '../components/cursos/pages/curso-descripcion-compra/curso-descripcion-compra.component';
import { CursoHabilitadoAlumnoComponent } from '../components/cursos/pages/curso-habilitado-alumno/curso-habilitado-alumno.component';
import { CursoModificacionComponent } from '../components/cursos/pages/curso-modificacion/curso-modificacion.component';
import { CursosConfiguracionComponent } from '../components/cursos/pages/cursos-configuracion/cursos-configuracion.component';
import { CursosDisponiblesCompraComponent } from '../components/cursos/pages/cursos-disponibles-compra/cursos-disponibles-compra.component';
import { CursosPerfilAlumnoComponent } from '../components/cursos/pages/cursos-perfil-alumno/cursos-perfil-alumno.component';
import { CursosListadoComponent } from '../components/cursos/pages/cursos-listado/cursos-listado.component';
import { CursosDetalleItemsComponent } from '../components/cursos/common/cursos-detalle-items/cursos-detalle-items.component';
import { LeccionAltaComponent } from '../components/cursos/pages/leccion-alta/leccion-alta.component';
import { LeccionModificacionComponent } from '../components/cursos/pages/leccion-modificacion/leccion-modificacion.component';
import { LeccionesConfiguracionComponent } from '../components/cursos/pages/lecciones-configuracion/lecciones-configuracion.component';
import { LeccionesListadoComponent } from '../components/cursos/pages/lecciones-listado/lecciones-listado.component';
import { MateriaAltaComponent } from '../components/cursos/pages/materia-alta/materia-alta.component';
import { MateriaModificacionComponent } from '../components/cursos/pages/materia-modificacion/materia-modificacion.component';
import { MateriasConfiguracionComponent } from '../components/cursos/pages/materias-configuracion/materias-configuracion.component';
import { MateriasListadoComponent } from '../components/cursos/pages/materias-listado/materias-listado.component';
import { PersonaAltaComponent } from '../components/usuarios/pages/persona-alta/persona-alta.component';
import { PersonasListadoComponent } from '../components/usuarios/pages/personas-listado/personas-listado.component';
import { PersonaModificacionComponent } from '../components/usuarios/pages/persona-modificacion/persona-modificacion.component';
import { GrupoFamiliarAltaComponent } from '@components/usuarios/pages/persona-modificacion/grupofamiliar-alta/grupofamiliar-alta.component';
import { CuentaComponent } from '../components/usuarios/pages/cuenta/cuenta.component';
import { ItemLeccionComponent } from '../components/cursos/pages/curso-habilitado-alumno/item-leccion/item-leccion.component';
import { RespuestasAltaComponent } from '../components/cursos/pages/evaluacion-preguntas-config/respuestas-alta/respuestas-alta.component';
import { CatedrasConfiguracionComponent } from '../components/cursos/pages/catedras-configuracion/catedras-configuracion.component';
import { CatedraAltaComponent } from '../components/cursos/pages/catedra-alta/catedra-alta.component';

// Imports
import { OfertasLaboralesModule } from './ofertas-laborales.module';
import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../app-routing.module';
import { MaterialModule } from './material.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CountUpModule } from 'ngx-countup';
import { StickyNavModule } from 'ng2-sticky-nav';
import { TabsModule } from 'ngx-tabset';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { LightboxModule } from 'ngx-lightbox';
import { AccordionModule } from 'ngx-accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { CursoTarjetaComponent } from '../components/cursos/common/curso-tarjeta/curso-tarjeta.component';
import { PipesModule } from './pipes.module';
import { CommonComponentsModule } from './common.components.module';
import { ModalRespuestaComponent } from '../components/cursos/pages/evaluacion-preguntas-config/respuestas-alta/modal-respuesta/modal-respuesta.component';
import { ModalModificarClaveComponent } from '../components/usuarios/pages/cuenta/modal-modificar-clave/modal-modificar-clave.component';
import { ModalModificarPresentacionComponent } from '../components/usuarios/pages/cuenta/modal-modificar-presentacion/modal-modificar-presentacion.component';
import { UsuariosAdministracionComponent } from '../components/usuarios/pages/usuarios-administracion/usuarios-administracion.component';
import { UsuariosListadoComponent } from '../components/usuarios/pages/usuarios-listado/usuarios-listado.component';
import { UsuarioModificacionComponent } from '../components/usuarios/pages/usuario-modificacion/usuario-modificacion.component';
import { UsuariosAltaComponent } from '../components/usuarios/pages/usuarios-alta/usuarios-alta.component';
import { OrdenarConceptosComponent } from '../components/cursos/pages/evaluacion-preguntas-config/respuestas-alta/ordenar-conceptos/ordenar-conceptos.component';
import { CuadriculaOpcionesComponent } from '../components/cursos/pages/evaluacion-preguntas-config/respuestas-alta/cuadricula-opciones/cuadricula-opciones.component';
import { ProfesorAltaComponent } from '../components/cursos/pages/profesor-alta/profesor-alta.component';
import { ProfesoresConfiguracionComponent } from '../components/cursos/pages/profesores-configuracion/profesores-configuracion.component';
import { ProfesoresListadoComponent } from '../components/cursos/pages/profesores-listado/profesores-listado.component';
import { ProfesorTarjetaPresentacionComponent } from '../components/cursos/common/profesor-tarjeta-presentacion/profesor-tarjeta-presentacion.component';
import { DatetimePickerModule } from './datetimepicker.module';
import { TableFilterPreInscripcionesComponent } from '../components/cursos/pages/table-filter-pre-inscripciones/table-filter-pre-inscripciones.component';
import { GrillaCursosModificarComponent } from '../components/cursos/pages/evaluacion-asociar-modificar/grilla-cursos-modificar/grilla-cursos-modificar.component';
import { GrillaUsuariosModificarComponent } from '../components/cursos/pages/evaluacion-asociar-modificar/grilla-usuarios-modificar/grilla-usuarios-modificar.component';
import { GrillaGrupoAfinidadModificarComponent } from '../components/cursos/pages/evaluacion-asociar-modificar/grilla-grupo-afinidad-modificar/grilla-grupo-afinidad-modificar.component';
import { GrillaCursosComponent } from '../components/cursos/pages/evaluacion-asociar/grilla-cursos/grilla-cursos.component';
import { GrillaUsuariosComponent } from '../components/cursos/pages/evaluacion-asociar/grilla-usuarios/grilla-usuarios.component';
import { GrillaGrupoAfinidadComponent } from '../components/cursos/pages/evaluacion-asociar/grilla-grupo-afinidad/grilla-grupo-afinidad.component';
import { EvaluacionConfigComponent } from '../components/cursos/pages/evaluacion-alta/evaluacion-config/evaluacion-config.component';
import { EvaluacionAsociarComponent } from '../components/cursos/pages/evaluacion-asociar/evaluacion-asociar.component';
import { EvaluacionAsociarModificarComponent } from '../components/cursos/pages/evaluacion-asociar-modificar/evaluacion-asociar-modificar.component';
import { EvaluacionConfigPreguntasComponent } from '../components/cursos/pages/evaluacion-alta-modificar/evaluacion-config-preguntas/evaluacion-config-preguntas.component';
import { EvaluacionInputPreguntasComponent } from '../components/cursos/pages/evaluacion-alta-modificar/evaluacion-input-preguntas/evaluacion-input-preguntas.component';
import { EvaluacionInputRespuestasComponent } from '../components/cursos/pages/evaluacion-alta-modificar/evaluacion-input-respuestas/evaluacion-input-respuestas.component';
import { EvaluacionModificarComponent } from '../components/cursos/pages/evaluacion-alta-modificar/evaluacion-modificar.component';
import { EvaluacionConfigModificarComponent } from '../components/cursos/pages/evaluacion-alta-modificar/evaluacion-config-modificar/evaluacion-config-modificar.component';
import { EvaluacionAltaComponent } from '../components/cursos/pages/evaluacion-alta/evaluacion-alta.component';
import { EvaluacionPreguntasConfigComponent } from '../components/cursos/pages/evaluacion-preguntas-config/evaluacion-preguntas-config.component';
import { ExamenEvaluacionDetalleComponent } from '../components/cursos/pages/examen-resultado-detalle/examen-evaluacion-detalle.component';
import { ExamenesEvaluacionesResultadosComponent } from '../components/cursos/pages/examenes-evaluaciones-resultados/examenes-evaluaciones-resultados.component';
import { ExamenRecuperatorioComponent } from '../components/cursos/pages/examen-recuperatorio/examen-recuperatorio.component';
import { ExamenesAlumnoComponent } from '../components/cursos/pages/examenes-alumno/examenes-alumno.component';
import { ExamenCursarComponent } from '../components/cursos/pages/examen-cursar/examen-cursar.component';
import { ExamenResultadoComponent } from '../components/cursos/pages/examen-resultado/examen-resultado.component';
import { ExamenesListadoComponent } from '../components/cursos/pages/examenes-listado/examenes-listado.component';
import { ExamenIntroduccionComponent } from '../components/cursos/pages/examen-introduccion/examen-introduccion.component';
import { MultipleChoiceComponent } from '../components/cursos/pages/examen-cursar/multiple-choice/multiple-choice.component';
import { VerdaderoFalsoComponent } from '../components/cursos/pages/examen-cursar/verdadero-falso/verdadero-falso.component';
import { ActividadesCursosComponent } from '../components/cursos/pages/actividades-cursos/actividades-cursos.component';
import { CalendarioCursoOnLineComponent } from '../components/cursos/pages/curso-habilitado-alumno/calendario-curso-on-line/calendario-curso-on-line.component';
import { ModalModificarClaveUsersComponent } from '../components/usuarios/pages/modal-modificar-clave/modal-modificar-clave.component';
import { ModalDetalleComponent } from '../components/usuarios/pages/modal-detalle/modal-detalle.component';
import { TitulosListadoComponent } from '../components/cursos/pages/titulos-listado/titulos-listado.component';
import { TituloAltaComponent } from '../components/cursos/pages/titulo-alta/titulo-alta.component';
import { TituloModificacionComponent } from '../components/cursos/pages/titulo-modificacion/titulo-modificacion.component';
import { MesasListadoComponent } from '../components/cursos/pages/mesas-listado/mesas-listado.component';
import { MesaAltaComponent } from '../components/cursos/pages/mesa-alta/mesa-alta.component';
import { MesaModificacionComponent } from '../components/cursos/pages/mesa-modificacion/mesa-modificacion.component';
import { GestosConfiguracionComponent } from '../components/cursos/pages/gestos-configuracion/gestos-configuracion.component';
import { GestosListadoComponent } from '../components/cursos/pages/gestos-listado/gestos-listado.component';
import { GestoModificacionComponent } from '../components/cursos/pages/gesto-modificacion/gesto-modificacion.component';
import { GestoAltaComponent } from '../components/cursos/pages/gesto-alta/gesto-alta.component';
import { ModalDetalleGecrosComponent } from '../components/usuarios/pages/modal-detalle-gecros/modal-detalle-gecros.component';
import { TiposOrdenConsultaComponent } from '@components/pages/tipos-orden-consulta/tipos-orden-consulta.component';
import { TipoOrdenFormDialogComponent } from '@components/pages/tipo-orden-form-dialog/tipo-orden-form-dialog.component';
import { OrdenesPeriodoComponent } from '@components/pages/tipo-ordenes-periodo/ordenes-periodo.component';
import { PushComponent } from '@components/push/push.component';
import { PushPreviewDialogComponent } from '@components/push/push-preview-dialog.component';
import { PushHistoryComponent } from '@components/push/push-history/push-history.component';
import { PushAdministracionComponent } from '@components/push/push-administracion/push-administracion.component';
import { PushDevicesDialogComponent } from '@components/push/push-devices-dialog/push-devices-dialog.component';
import { FamiliarModalAltaComponent } from '../components/usuarios/pages/persona-modificacion/familiar-modal-alta/familiar-modal-alta.component'
import { MisMensajesComponent } from '../components/mis-mensajes/mis-mensajes.component';

@NgModule({
    declarations: [
        CursosListarComponent,
        CursoAltaComponent,
        CursoCompraComponent,
        CursosAlumnosModificarComponent,
        CursosListadoAlumnoCursosComponent,
        CursoDescripcionCompraComponent,
        CursoHabilitadoAlumnoComponent,
        CursoModificacionComponent,
        CursosConfiguracionComponent,
        CursosDisponiblesCompraComponent,
        CursosPerfilAlumnoComponent,
        CursosListadoComponent,
        CursosDetalleItemsComponent,
        EvaluacionAltaComponent,
        EvaluacionPreguntasConfigComponent,
        EvaluacionAsociarComponent,
        EvaluacionAsociarModificarComponent,
        LeccionAltaComponent,
        LeccionModificacionComponent,
        LeccionesConfiguracionComponent,
        LeccionesListadoComponent,
        MateriaAltaComponent,
        MateriaModificacionComponent,
        MateriasConfiguracionComponent,
        MateriasListadoComponent,
        PersonaAltaComponent,
        PersonasListadoComponent,
        PersonaModificacionComponent,
        GrupoFamiliarAltaComponent,
        ItemLeccionComponent,
        MultipleChoiceComponent,
        VerdaderoFalsoComponent,
        RespuestasAltaComponent,
        CatedrasConfiguracionComponent,
        CatedraAltaComponent,
        ModalRespuestaComponent,
        EvaluacionConfigComponent,
        EvaluacionConfigModificarComponent,
        OrdenarConceptosComponent,
        CuadriculaOpcionesComponent,
        GrillaCursosComponent,
        GrillaUsuariosComponent,
        GrillaGrupoAfinidadComponent,
        GrillaCursosModificarComponent,
        GrillaUsuariosModificarComponent,
        GrillaGrupoAfinidadModificarComponent,
        ProfesorAltaComponent,
        ProfesoresListadoComponent,
        ProfesoresConfiguracionComponent,
        TableFilterPreInscripcionesComponent,
        TitulosListadoComponent,
        TituloAltaComponent,
        // Componentes en common de Cursos
        CuentaComponent,
        CursoTarjetaComponent,
        ProfesorTarjetaPresentacionComponent,
        UsuariosAdministracionComponent,
        UsuariosListadoComponent,
        UsuarioModificacionComponent,
        UsuariosAltaComponent,

        //push
        PushComponent,
        PushPreviewDialogComponent,
        PushHistoryComponent,
        PushAdministracionComponent,
        PushDevicesDialogComponent,
        MisMensajesComponent,

        // Modal de cuenta - hay que sacarlo eh unificar en un modulo common
        ModalModificarClaveComponent,
        ModalModificarClaveUsersComponent,
        ModalModificarPresentacionComponent,
        ExamenesListadoComponent,
        ExamenesAlumnoComponent,
        ExamenIntroduccionComponent,
        ExamenCursarComponent,
        ExamenResultadoComponent,
        ExamenesEvaluacionesResultadosComponent,
        ExamenEvaluacionDetalleComponent,
        EvaluacionModificarComponent,
        EvaluacionConfigPreguntasComponent,
        EvaluacionInputPreguntasComponent,
        EvaluacionInputRespuestasComponent,
        ExamenRecuperatorioComponent,
        ActividadesCursosComponent,
        CalendarioCursoOnLineComponent,
        TituloModificacionComponent,
        MesasListadoComponent,
        MesaAltaComponent,
        MesaModificacionComponent,
        GestosConfiguracionComponent,
        GestosListadoComponent,
        GestoAltaComponent,
        GestoModificacionComponent,
        ModalDetalleComponent,
        ModalDetalleGecrosComponent,

        // Ordenes
        TipoOrdenFormDialogComponent,
        TiposOrdenConsultaComponent,
        OrdenesPeriodoComponent,

        FamiliarModalAltaComponent
    ],
    imports: [
        OfertasLaboralesModule,
        ChartsModule,
        CommonModule,
        AppRoutingModule,
        MaterialModule,
        CarouselModule,
        BrowserAnimationsModule,
        CountUpModule,
        StickyNavModule,
        TabsModule,
        NgxScrollTopModule,
        LightboxModule,
        AccordionModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        GalleryModule,
        PipesModule,
        CommonComponentsModule,
        DatetimePickerModule,
    ],
    exports: [
        CursoAltaComponent,
        CursoCompraComponent,
        CursoDescripcionCompraComponent,
        CursoHabilitadoAlumnoComponent,
        CursoModificacionComponent,
        CursosConfiguracionComponent,
        CursosDisponiblesCompraComponent,
        CursosPerfilAlumnoComponent,
        EvaluacionAltaComponent,
        EvaluacionModificarComponent,
        EvaluacionPreguntasConfigComponent,
        EvaluacionAsociarComponent,
        EvaluacionAsociarModificarComponent,
        LeccionAltaComponent,
        LeccionesConfiguracionComponent,
        MateriaAltaComponent,
        MateriaModificacionComponent,
        MateriasConfiguracionComponent,

        EvaluacionConfigComponent,
        OrdenarConceptosComponent,
        CuadriculaOpcionesComponent,
        GrillaCursosComponent,
        GrillaUsuariosComponent,
        GrillaGrupoAfinidadComponent,
        GrillaCursosModificarComponent,
        GrillaUsuariosModificarComponent,
        GrillaGrupoAfinidadModificarComponent,
        GrillaCursosModificarComponent,
        GrillaGrupoAfinidadModificarComponent,
        CursosListarComponent,
        VerdaderoFalsoComponent,
        MultipleChoiceComponent,
        ActividadesCursosComponent,
        CursosListadoAlumnoCursosComponent,
        CursosAlumnosModificarComponent,

        // Componentes en common
        CursoTarjetaComponent,
        ProfesorTarjetaPresentacionComponent,
        CursosDetalleItemsComponent,
        UsuariosAdministracionComponent,
        UsuariosAltaComponent,

        // Modal de cuenta - hay que sacarlo eh unificar en un modulo common
        ModalModificarClaveComponent,
        ModalModificarPresentacionComponent,
        CatedrasConfiguracionComponent,
        CatedraAltaComponent,
        PushHistoryComponent,
        MisMensajesComponent,

        TituloModificacionComponent,
        MesaAltaComponent,
        ModalDetalleComponent,
    ],
})
export class CursosModule {}
